export default "__VITE_ASSET__CmR1D0G5__"